export default "__VITE_ASSET__QlxbbrX4__"